export default {
  getUser: state => (state.loaded ? state.user : false),
  getUserID: state => (state.loaded ? parseInt(state.user.id) : false),
  getUserName: state => (state.loaded ? state.user.username : false),
  getUserAccountID: state =>
    state.loaded ? parseInt(state.user.account.id) : false,
  isUserLoaded: state => state.loaded,
  isAdmin: state =>
    state.loaded
      ? typeof state.user.admin === 'undefined'
        ? false
        : state.user.admin
      : false,
  isSuperAdmin: state =>
    state.loaded
      ? typeof state.user.super_admin === 'undefined'
        ? false
        : state.user.super_admin
      : false,
  isMasqueraded: state => state.masqueraded,
  isPartner: state =>
    state.loaded ? state.user.account_type === 'ACCOUNT' : false,
  isCustomer: state =>
    state.loaded ? state.user.account_type === 'CUSTOMER' : false,
  canMasquerade: (state, getters) => getters.isAdmin || getters.isMasqueraded,
  getUserAccountName: state => (state.loaded ? state.user.account.name : false),
  getUserFullName: state => (state.loaded ? state.user.full_name : false),
  getUserTimeZone: state =>
    state.loaded ? state.timeZone : 'Australia/Sydney',
  isMemberOfTeam: state => ref => {
    if (state.user.has_team) {
      Object.keys(state.user.teams).forEach(team => {
        if ('ref' in team && team.ref === ref) {
          return true
        }
      })
    }

    return false
  },
  hasPermission: state => ref => {
    Object.keys(state.user.permissions).forEach(access => {
      if ('ref' in access && access.ref === ref) {
        return true
      }
    })

    return false
  }
}
